import { render, staticRenderFns } from "./BannerAdMess.vue?vue&type=template&id=6af6ca4e&scoped=true&"
import script from "./BannerAdMess.vue?vue&type=script&lang=js&"
export * from "./BannerAdMess.vue?vue&type=script&lang=js&"
import style0 from "./BannerAdMess.vue?vue&type=style&index=0&id=6af6ca4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af6ca4e",
  null
  
)

export default component.exports